export default __webpack_public_path__ + "static/media/rent.481235a5.png";